import type { SessionContextItem } from './SessionContext';

/** Shared defensive check so an ineligible item cannot leave an empty metadata slot. */
export const isLinkableSessionContext = (
	context: SessionContextItem,
): context is SessionContextItem & { url: string } => {
	const url = context.url?.trim();
	if (!context.label.trim() || !url) {
		return false;
	}
	if (
		(context.type === 'file' || context.type === 'image') &&
		url.startsWith('/') &&
		!url.startsWith('//')
	) {
		return true;
	}

	try {
		const parsedUrl = new URL(url);
		return parsedUrl.protocol === 'https:' || parsedUrl.protocol === 'http:';
	} catch {
		return false;
	}
};
